import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { MedChronEvent } from './schemas'

export type MedChronEventsState = {
  events: { [storeKey: string]: MedChronEvent[] }
}

const initialState: MedChronEventsState = {
  events: {},
}

export const medChronEventsSlice = createSlice({
  name: 'medChronEventsState',
  initialState,
  reducers: {
    nullifyData: () => initialState,

    setEventsList: (state, action: PayloadAction<{ storeKey: string; events: MedChronEvent[] }>) => {
      state.events[action.payload.storeKey] = action.payload.events
    },
  },
})

// Actions
export const MedChronEventsActions = medChronEventsSlice.actions

export default medChronEventsSlice.reducer
